<template>
  <div class="section-content">
    <schedule-center
      :base-url="serveUrl"
      :admin-center-url="adminCenterUrl"
      :request="request"
      show-calendar
      :showFilter = "HIDE_SCHEDULE_SEARCH !== '1'"
    ></schedule-center>
  </div>
</template>
<script>
  import configR from '@/configs.js';
  import request from '@/utils/request';
  export default {
    name: "PortalScheduleCenter",
    data(){
      return {
        serveUrl:configR.envConfigs.PORTAL_API,
        HIDE_SCHEDULE_SEARCH:configR.envConfigs.HIDE_SCHEDULE_SEARCH,
        adminCenterUrl:configR.envConfigs.ADMIN_CENTER_API,
        request:request
      }
    },
    computed: {

    },
  };
</script>

<style lang="scss">
  @import "@/styles/variables.scss";

  .section-content {
    width: 1680px;
    margin: 0 auto;
    @include portalMedia;
    .schedule-center {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
    }
  }

</style>
